import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL || ''

class FetchData {
  static async userProfile() {
    const { data } = await axios.get(`${API_URL}/user/profile`, {
      withCredentials: true,
    })

    return data
  }

  static async userInsights() {
    const { data } = await axios.get(`${API_URL}/users/insights`, {
      withCredentials: true,
    })
    return data
  }

  static async feedFaq(categories) {
    try {
      const { data } = await axios.get(`${API_URL}/chats/feedFaq`, {
        params: { categories },
      })
      return data
    } catch (e) {
      console.warn('Failed to fetch feed FAQs:', e.message)
      return []
    }
  }
}

export default FetchData
